import { object } from 'prop-types'
import Div from '@ui/layout/Div'
import Image from '@ui/elements/Image'
import Icon from '@ui/elements/Icon'
import { useTranslation } from 'react-i18next'
import useToggle from '@hook/useToggle'
import useDownloadFile from '@hook/useDownloadFile'

const MissionPilotVign = ({ pilot }) => {
  const { fullName, cellPhone, email, avatar, documents } = pilot
  const [t] = useTranslation('mission')
  const [isActive, toggleActive] = useToggle(false)
  const downLoadFile = useDownloadFile()

  const renderDocuments = () => {
    return documents.map(document => {
      const { id, name } = document
      return <Icon
        spanClass='pilot-document'
        icon='icon-download'
        label={document.name}
        callback={() => downLoadFile(`${import.meta.env.VITE_API_URL}/api/documents/${id}/download`, name, 'pdf')}
        key={`pilot-document-${document.id}`}
      />
    })
  }

  return (
    <Div cssClass='mission-pilot-vign column is-6'>
      <Div cssClass='vign-content'>
        <Div cssClass='pilot-header'>
          <Div cssClass='infos'>
            <h3>{fullName}</h3>
            <Div cssClass='contact-infos'>
              <Icon icon='icon-call' label={cellPhone} areaLabel={t('labels.pilot_cellphone')} />
              <Icon icon='icon-mail_outline' label={email} areaLabel={t('labels.pilot_email')} />
            </Div>
          </Div>
          <Div cssClass='avatar'>
            <Image src={avatar} alt={`${fullName} avatar`} />
          </Div>
          <Icon spanClass='toggle-pilot-vign' icon={`${isActive ? 'icon-keyboard_arrow_down' : 'icon-keyboard_arrow_up'}`} callback={toggleActive} />
        </Div>
        <Div cssClass={`pilot-docs ${isActive ? '' : 'is-hidden'}`}>
          {renderDocuments()}
        </Div>
      </Div>
    </Div>
  )
}

MissionPilotVign.propTypes = {
  pilot: object
}

export default MissionPilotVign
